import styled, { keyframes, css } from 'styled-components'
import { Box } from 'rebass'

const animationName = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }`

const animation = ({ delay = '0s' }) => css`${animationName} 2s infinite alternate ${delay};`

const Placeholder = styled(Box)`
  width: 90%;
  height: 18px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-right: 15px;
  animation: ${animation};
`

export default Placeholder
